/** Page size for badge/banner count fetches (only `total` is needed). */
export const PENDING_INVITE_COUNT_PER_PAGE = 1;

/** Skip non-forced refetches within this window after a successful load. */
export const PENDING_INVITE_FRESHNESS_MS = 30_000;
